import VsSelectOverwriteHandler from './handle-event.js';

export default {
    install(Vue, options = { }) {
        if (Vue.__vsSelectOverwriteInstalled) return;

        const handler = new VsSelectOverwriteHandler(options);
        handler.__install();

        Vue.prototype.$vsSelectOverwriteEvents = handler;
        Vue.__vsSelectOverwriteInstalled = true;
    }
}